import { NitroModules } from "react-native-nitro-modules";
var hybrid;
function audioNative() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneAudio");
  return hybrid;
}
export {
  audioNative
};
//# sourceMappingURL=hybrid.native.js.map
